import { useTranslation } from "react-i18next"

import { connect } from "react-redux"

import DayJS from "react-dayjs"

import Container from "@mui/material/Container"
import Chip from "@mui/material/Chip"

import TodayIcon from "@mui/icons-material/Today"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import EuroIcon from "@mui/icons-material/Euro"
import EventIcon from "@mui/icons-material/Event"
import RotateRightIcon from "@mui/icons-material/RotateRight"
import ReportIcon from "@mui/icons-material/Report"

import NumberFormat from "react-number-format"

import Grid from "@mui/material/Grid"
import Divider from "@mui/material/Divider"

import VoucherHeaderButtons from "./VoucerHeaderButtons"
import { isEditable } from "../utils/makeDocument"

import Defines from "../defines"

import dayjs from "dayjs"

const VoucherChips = ({ data, initials }) => {
  const { t } = useTranslation([
    "voucherHeader",
    "voucherType",
    "voucherStatus",
  ])
  const summa =
    data && data.viennit
      ? "" +
        data.viennit.reduce(
          (acc, cur) =>
            acc + (parseFloat(cur.debet) ? parseFloat(cur.debet) : 0),
          0.0
        )
      : ""

  const kierto =
    data.kierto && initials.kierrot.find((e) => e.id === data.kierto)

  return (
    <div>
      {data.tunniste && (
        <Chip
          variant="outlined"
          size="large"
          label={(data.sarja ? data.sarja : "") + data.tunniste}
        />
      )}
      <Chip
        variant="outlined"
        size="large"
        label={<DayJS format="DD.MM.YYYY" date={data.pvm} />}
        icon={<CalendarTodayIcon />}
      />
      {data.laskupvm && data.laskupvm !== data.pvm && (
        <Chip
          variant="outlined"
          size="large"
          label={<DayJS format="DD.MM.YYYY" date={data.laskupvm} />}
          icon={<TodayIcon />}
        />
      )}
      {data.erapvm && (
        <Chip
          variant="outlined"
          size="large"
          label={<DayJS format="DD.MM.YYYY" date={data.erapvm} />}
          icon={<EventIcon />}
        />
      )}
      <Chip
        variant="outlined"
        size="large"
        label={t("voucherType:" + (data.tyyppi > 0 ? data.tyyppi : "0"))}
      />
      {kierto && (
        <Chip
          variant="outlined"
          size="large"
          label={kierto.nimi}
          icon={<RotateRightIcon />}
        />
      )}
      <Chip
        variant="outlined"
        size="large"
        label={t("voucherStatus:" + data.tila)}
      />
      <Chip
        variant="outlined"
        size="large"
        label={
          <NumberFormat
            value={parseFloat(summa)}
            displayType="text"
            decimalSeparator=","
            thousandSeparator="&nbsp;"
            fixedDecimalScale={true}
            decimalScale={2}
          />
        }
        icon={<EuroIcon />}
      />
      {data.huomio && (
        <Chip
          label={t("marked")}
          icon={<ReportIcon />}
          size="large"
          color="secondary"
        />
      )}
    </div>
  )
}

const VoucherHeaderBody = ({ data }) => {
  return (
    <div>
      <h2>{data.otsikko}</h2>
      {data.kumppani && <p>{data.kumppani.nimi}</p>}
      {data.info && (
        <div style={{ whiteSpace: "pre-line" }}>          
          <p>{data.info}</p>
        </div>
      )}
    </div>
  )
}

const VoucherHeader = ({ data, initials, current }) => {
  const closeDaySetting = initials.asetukset["TilitPaatetty"]
  const closeDay = closeDaySetting
    ? dayjs(closeDaySetting).add(1, "day")
    : dayjs("2020-01-01")
  const voucherDate = dayjs(data.pvm)
  const unLocked = closeDay.isBefore(voucherDate)
  const editable = current.rights.includes("Tt") && isEditable(data) && unLocked


  const buttonsVisible =
    ( data.tila >= Defines.VoucherStatus.Received &&
      data.tila <= Defines.VoucherStatus.Accepted &&
      (current.rights.includes("Kt") || current.rights.includes("Kh"))) || editable
      


  return (    
      <Container text maxWidth="xl">
        <Grid container spacing={2} direction="row-reverse">
        {buttonsVisible && (
            <Grid item sm={4} xs={12}>
              <VoucherHeaderButtons data={data} editable={editable}/>
            </Grid>
          )}          
          <Grid item sm={buttonsVisible ? 8 : 12} xs={12}>
            <VoucherChips data={data} initials={initials} />
            <VoucherHeaderBody data={data} />
          </Grid>

        </Grid>
      </Container>    
  )
}

const mapStateToProps = (state) => {
  return {
    initials: state.cloud.init,
    current: state.cloud.current,
  }
}

export default connect(mapStateToProps, {})(VoucherHeader)
